<template>
  <ModalDialog
    pop-name="事件票プレビュー"
    dialog-width="62%"
    dialog-height="auto"
    margin-class="mbm-3 mtp-3"
    @close="closeModal"
  >
    <template #header> </template>
    <template #body>
      <div>
        <div v-if="!show" id="printThis" class="page-body-font mtp-3">
          <div v-for="(item, index) in list" :key="index">
            <div class="col-12 d-flex justify-content-end">
              <b>{{ item.type }}</b>
            </div>
            <div class="col-12 d-flex justify-content-center mtp-3 mbm-3">
              <b>
                予&emsp;防&emsp;司&emsp;法&emsp;支&emsp;援&emsp;事&emsp;件&emsp;票
              </b>
            </div>
            <table class="col-12 table mtp-3 mbm-0">
              <tbody>
                <tr>
                  <td colspan="25">
                    <div>受&emsp;理&emsp;年&emsp;月&emsp;日</div>
                    <div>整&emsp;&ensp;理&emsp;&ensp;番&emsp;&ensp;号</div>
                  </td>
                  <td colspan="25">回答予定年月日</td>
                  <td colspan="25">回答年月日</td>
                  <td colspan="25">回&emsp;答&emsp;方&emsp;法</td>
                </tr>
                <tr>
                  <td colspan="25">
                    <div>{{ item.d1[0] }}</div>
                    <div>{{ item.d1[1] }}</div>
                  </td>
                  <td colspan="25">{{ item.d2 }}</td>
                  <td colspan="25">{{ item.d3 }}</td>
                  <td v-dompurify-html="item.d4" colspan="25"></td>
                </tr>
                <tr>
                  <td colspan="5">処<br />理<br />&emsp;<br />区<br />分</td>
                  <td colspan="20">{{ item.e1 }}</td>
                  <td colspan="12">主&emsp;管&emsp;課</td>
                  <td colspan="38" align="left">{{ item.e2 }}</td>
                  <td colspan="5">担<br />当<br />者</td>
                  <td colspan="20" align="left">{{ item.e3 }}</td>
                </tr>

                <tr>
                  <td colspan="25">件&emsp;&emsp;&emsp;名</td>
                  <td colspan="75" align="left">{{ item.f1 }}</td>
                </tr>
                <tr>
                  <td colspan="25">照&emsp;会&emsp;庁</td>
                  <td colspan="75" align="left">{{ item.g1 }}</td>
                </tr>

                <tr>
                  <td class="pad10" colspan="5">
                    照<br />会<br />事<br />案<br />の<br />概<br />要
                  </td>
                  <td class="pad10" colspan="95" align="left" valign="top">
                    {{ item.i1 }}
                  </td>
                </tr>
                <tr>
                  <td class="pad10" colspan="5">回<br />答<br />要<br />旨</td>
                  <td class="pad10" colspan="95" align="left" valign="top">
                    {{ item.j1 }}
                  </td>
                </tr>
                <tr>
                  <td class="pad10" colspan="5">関<br />連<br />事<br />件</td>
                  <td class="pad10" colspan="95" align="left" valign="top">
                    {{ item.k1 }}
                  </td>
                </tr>
                <tr>
                  <td class="pad10" colspan="5">
                    備<br />&emsp;<br />&emsp;<br />考
                  </td>
                  <td class="pad10" colspan="95" align="left" valign="top">
                    {{ item.l1 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="show" id="printThis" class="page-body-font mtp-3">
          <div v-for="(item, index) in list1" :key="index">
            <div>
              <b>{{ item.type }}</b>
            </div>
            <table class="border col-12 table mb-0">
              <tbody>
                <tr>
                  <td colspan="50">
                    <div
                      class="col-12 d-flex justify-content-between align-items-center"
                    >
                      <div>
                        {{ item.a1 }}
                      </div>
                      <div>
                        {{ item.a2 }}
                      </div>

                      <div class="col-2">殿</div>
                    </div>
                  </td>
                  <td colspan="7">発<br />送</td>
                  <td colspan="43" align="left">
                    <div>
                      {{ item.a3[0] }}
                    </div>
                    <div class="mtp-3">
                      {{ item.a3[1] }}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colspan="37">
                    <div
                      class="col-12 d-flex justify-content-center align-items-center"
                    >
                      <div class="col-6 pe-2" align="right">
                        <div>受&emsp;&emsp;理</div>
                        <div class="mtp-3">結&emsp;&emsp;果</div>
                      </div>
                      <div class="col-6 ps-2" align="left">{{ item.b1 }}</div>
                    </div>
                  </td>
                  <td colspan="8">報<br />告<br />局</td>
                  <td colspan="55" align="left">
                    {{ item.b2 }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="col-12 d-flex justify-content-center mtp-3 mbm-3">
              <b>
                予&emsp;防&emsp;司&emsp;法&emsp;支&emsp;援&emsp;事&emsp;件&emsp;票
              </b>
            </div>
            <table class="col-12 table mbm-0">
              <tbody>
                <tr>
                  <td colspan="25">
                    <div>受&emsp;理&emsp;年&emsp;月&emsp;日</div>
                    <div>整&emsp;&ensp;理&emsp;&ensp;番&emsp;&ensp;号</div>
                  </td>
                  <td colspan="25">回答予定年月日</td>
                  <td colspan="25">回答年月日</td>
                  <td colspan="25">回&emsp;答&emsp;方&emsp;法</td>
                </tr>
                <tr>
                  <td colspan="25">
                    <div>{{ item.d1[0] }}</div>
                    <div>{{ item.d1[1] }}</div>
                  </td>
                  <td colspan="25">{{ item.d2 }}</td>
                  <td colspan="25">{{ item.d3 }}</td>
                  <td v-dompurify-html="item.d4" colspan="25"></td>
                </tr>
                <tr>
                  <td colspan="5">処<br />理<br />区<br />分</td>
                  <td colspan="20">{{ item.e1 }}</td>
                  <td colspan="12">主&emsp;管&emsp;課</td>
                  <td colspan="38" align="left">{{ item.e2 }}</td>
                  <td colspan="5">担<br />&emsp;<br />当</td>
                  <td colspan="20" align="left">{{ item.e3 }}</td>
                </tr>

                <tr>
                  <td colspan="25">件&emsp;&emsp;&emsp;名</td>
                  <td colspan="75" align="left">{{ item.f1 }}</td>
                </tr>
                <tr>
                  <td colspan="25">照&emsp;会&emsp;庁</td>
                  <td colspan="75" align="left">{{ item.g1 }}</td>
                </tr>

                <tr>
                  <td class="pad10" colspan="5">
                    照<br />会<br />事<br />案<br />の<br />概<br />要
                  </td>
                  <td class="pad10" colspan="95" align="left" valign="top">
                    {{ item.i1 }}
                  </td>
                </tr>
                <tr>
                  <td class="pad10" colspan="5">回<br />答<br />要<br />旨</td>
                  <td class="pad10" colspan="95" align="left" valign="top">
                    {{ item.j1 }}
                  </td>
                </tr>
                <tr>
                  <td class="pad10" colspan="5">関<br />連<br />事<br />件</td>
                  <td class="pad10" colspan="95" align="left" valign="top">
                    {{ item.k1 }}
                  </td>
                </tr>
                <tr>
                  <td class="pad10" colspan="5">
                    備<br />&emsp;<br />&emsp;<br />考
                  </td>
                  <td class="pad10" colspan="95" align="left" valign="top">
                    {{ item.l1 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="d-flex justify-content-center">
        <ButtonMain v-print="print" button-name="印刷"></ButtonMain>
        <ButtonNormal
          class="ms-4"
          button-name="複数事件票確認用"
          @click="buttoncheck"
        ></ButtonNormal>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'CaseSheetPrintingDialog',
  props: {
    list: Array,
    list1: Array
  },
  data() {
    return {
      show: true,
      print: {
        id: 'printThis',
        popTitle: '',
        preview: false,
        previewTitle: '',
        previewPrintBtnLabel: '',
        zIndex: 20002,
        beforeOpenCallback: () => {},
        openCallback: () => {},
        closeCallback: () => {},
        previewBeforeOpenCallback: () => {},
        previewOpenCallback: () => {},
        standard: 'HTML5',
        extraHead: '',
        clickMounted: () => {},
        url: '',
        asyncUrl: ''
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    buttoncheck() {
      this.show = !this.show
    },
    Printing() {
      var hkey_key = hkey_key
      var hkey_root = 'HKEY_CURRENT_USER'
      var hkey_path = '"\Software\Microsoft\Internet Explorer\PageSetup"'

      // 印刷場合のヘッダーとフッターを空に設定する
      function pagesetup_null() {
        try {
          var RegWsh = new ActiveXObject('WScript.Shell')
          hkey_key = 'header'
          RegWsh.RegWrite(hkey_root + hkey_path + hkey_key, '')
          hkey_key = 'footer'
          RegWsh.RegWrite(hkey_root + hkey_path + hkey_key, '')
        } catch (e) {
          console.log()
        }
      }
      pagesetup_null()

      window.print()
    }
  }
}
</script>
<style scoped lang="scss">
table {
  table-layout: fixed;
  text-align: center;
  vertical-align: middle;
  border-top: none !important;
  td {
    padding: 0.5rem;
    border: 1px solid rgb(177, 177, 177);
  }
}

.tb-rl {
  writing-mode: tb-rl;
}

.text-vertical {
  line-height: 48px;
}
.pad10 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
</style>
